import { render, staticRenderFns } from "./NewAlert.vue?vue&type=template&id=c1bbf27c&scoped=true&"
import script from "./NewAlert.vue?vue&type=script&lang=ts&"
export * from "./NewAlert.vue?vue&type=script&lang=ts&"
import style0 from "./NewAlert.vue?vue&type=style&index=0&id=c1bbf27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bbf27c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
